import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class BusinessVerticalsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/business_verticals", { params: toSnakeCase(params) });
  }
}

export default new BusinessVerticalsService();
